/**
 * 納期確認機能 (2026-08-20 追加)
 *
 * 在庫切れ商品ページの「次回納期を確認する」ボタンをクリックすると、
 * Shopify標準のお問い合わせフォーム機構(contact form)に対して、
 * 商品名・バリアント・数量・商品URLをまとめたメッセージを送信する。
 *
 * ログイン中の会員: customer.email が既に分かっているため、確認なしでそのまま送信。
 * 非会員(ゲスト): 返信先が分かるよう、メールアドレスの入力のみを1つお願いしてから送信する。
 */
function initLeadTimeInquiryButton(btn) {
  // バリアント変更時にボタン要素が丸ごと差し替えられた場合(global.jsのVariantSelects側で
  // 「次回納期を確認する」ボタンに切り替わった際)にも再度呼び出せるよう、関数として切り出し、
  // window経由でも呼び出せるようにしている。同じ要素に二重でイベントを貼らないようガードする。
  if (!btn || btn.dataset.leadTimeInquiryBound === 'true') return;
  btn.dataset.leadTimeInquiryBound = 'true';
  btn.addEventListener('click', (evt) => {
    evt.preventDefault();
    handleLeadTimeInquiryClick(btn);
  });
}
window.initLeadTimeInquiryButton = initLeadTimeInquiryButton;

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-lead-time-inquiry]').forEach((btn) => {
    initLeadTimeInquiryButton(btn);
  });
});

function handleLeadTimeInquiryClick(btn) {
  const sectionId = btn.dataset.sectionId;
  if (!sectionId) return;

  const form = document.getElementById(`LeadTimeContactForm-${sectionId}`);
  const emailField = document.getElementById(`LeadTimeContactEmail-${sectionId}`);
  const bodyField = document.getElementById(`LeadTimeContactBody-${sectionId}`);
  if (!form || !emailField || !bodyField) return;

  const productForm = btn.closest('product-form');
  const variantIdInput = productForm ? productForm.querySelector('[name="id"]') : null;
  const variantId = variantIdInput ? variantIdInput.value : null;

  const quantityInput = document.getElementById(`Quantity-${sectionId}`);
  const quantity = quantityInput && quantityInput.value ? quantityInput.value : '1';

  let variantTitle = '';
  const variantDataEl = document.getElementById(`LeadTimeVariantData-${sectionId}`);
  if (variantDataEl && variantId) {
    try {
      const variants = JSON.parse(variantDataEl.textContent);
      const match = variants.find((v) => String(v.id) === String(variantId));
      if (match && match.title && match.title !== 'Default Title') {
        variantTitle = match.title;
      }
    } catch (e) {
      // 解析できない場合はバリアント名なしで続行
    }
  }

  const submit = (email) => {
    emailField.value = email;
    const lines = [
      '【納期確認リクエスト】',
      `商品名: ${btn.dataset.productTitle || ''}`,
      `バリアント: ${variantTitle || '(単一バリアント)'}`,
      `数量: ${quantity}`,
      `商品ページ: ${btn.dataset.productUrl || ''}`,
    ];
    bodyField.value = lines.join('\n');

    btn.setAttribute('aria-disabled', 'true');
    const label = btn.querySelector('span');
    if (label) label.textContent = btn.dataset.labelSending || label.textContent;
    const spinner = btn.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');

    form.submit();
  };

  // 会員: すでにメールアドレスが分かっているので確認なしで送信
  if (emailField.value) {
    submit(emailField.value);
    return;
  }

  // 非会員: メールアドレスの入力を1つだけお願いする
  const prompt = document.getElementById(`LeadTimeEmailPrompt-${sectionId}`);
  if (!prompt) {
    // 想定外(会員判定できずプロンプトも無い場合)は何もしない
    return;
  }
  prompt.hidden = false;
  prompt.scrollIntoView({ behavior: 'smooth', block: 'center' });

  const input = document.getElementById(`LeadTimeEmailInput-${sectionId}`);
  const submitBtn = document.getElementById(`LeadTimeEmailSubmit-${sectionId}`);
  const errorMsg = prompt.querySelector('.lead-time-email-error');
  if (!input || !submitBtn) return;

  input.focus();

  const onSubmit = () => {
    const value = (input.value || '').trim();
    // ごく簡易なメール形式チェック(厳密なバリデーションはサーバー側/フォーム側にも依存)
    if (!value || value.indexOf('@') === -1 || value.indexOf('.') === -1) {
      if (errorMsg) errorMsg.hidden = false;
      return;
    }
    submitBtn.removeEventListener('click', onSubmit);
    submit(value);
  };
  submitBtn.addEventListener('click', onSubmit);

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSubmit();
    }
  });
}
